import { render } from "./AddEditPurchase.vue?vue&type=template&id=ffb95cca&scoped=true"
import script from "./AddEditPurchase.vue?vue&type=script&lang=js"
export * from "./AddEditPurchase.vue?vue&type=script&lang=js"

import "./AddEditPurchase.vue?vue&type=style&index=0&id=ffb95cca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb95cca"]])

export default __exports__